document.addEventListener("DOMContentLoaded", () => {
  // const row1 = document.querySelector(".row1");
  const row2 = document.querySelector(".row2");
  if (row2) {
    // setContinuousScroll(row1, "left");
    setContinuousScroll(row2, "right");
  }

  let swiper_videos_elm = document.querySelector('.swiper-videos');
  if (swiper_videos_elm) {
    const swiperVideos = new Swiper(swiper_videos_elm, {
      slidesPerView: 2.12,
      spaceBetween: 20,
      breakpoints: {
        991.98: {
          slidesPerView: 2.80,
          spaceBetween: 25
        }
      },
      grabCursor: true,
      speed: 800,
      loop: true,
      navigation: {
        nextEl: '.swiper-videos .next',
        prevEl: '.swiper-videos .prev',
      },
      on: {
        init: function () {
          const swiper_slide_iframes = document.querySelectorAll('.swiper-slide iframe');
          if (swiper_slide_iframes && swiper_slide_iframes.length > 0) {
            const modal = document.getElementById('modal-video');
            const modalIframe = modal.querySelector('iframe');
            const closeModalBtn = document.getElementById('close-modal');
            // Function to open modal
            const openModal = (videoSrc) => {
              modalIframe.src = videoSrc;
              modal.style.display = 'flex';
              document.body.style.overflow = 'hidden'; // Prevent scrolling when modal is open
            };

            // Function to close modal
            const closeModal = () => {
              modal.style.display = 'none';
              modalIframe.src = ''; // Clear iframe source to stop video
              document.body.style.overflow = ''; // Restore scrolling
            };

            // Add click event to each video slide
            swiper_slide_iframes.forEach(iframe => {
              const src = iframe.src;
              iframe.allow = '';
              iframe.closest('.swiper-slide').addEventListener('click', (e) => {
                e.preventDefault();
                openModal(src);
              });
            });

            // Close modal when clicking the close button
            if (closeModalBtn) {
              closeModalBtn.addEventListener('click', (e) => {
                e.preventDefault();
                closeModal();
              });
            }

            // Close modal when clicking outside the content
            modal.addEventListener('click', (e) => {
              if (e.target === modal) {
                closeModal();
              }
            });
          }
        },
      },
    });
  }

});
const setContinuousScroll = (row, direction) => {
  const w = row.scrollWidth;
  gsap.set(row, {x: 0});

  gsap.to(row, {
    x: w,
    duration: 130,
    ease: "none",
    repeat: -1,
    modifiers: {
      x: (x) => {
        const xValue = parseFloat(x);
        // if (direction === "left" && xValue <= -w) return 0;
        if (direction === "right" && xValue >= w) return 0;
        return x;
      }
    }
  });
};
